import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ButtonComponent } from "./button/button.component";
import { TextareaComponent } from './textarea/textarea.component';
import { InputComponent } from './input/input.component';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [ButtonComponent, TextareaComponent, InputComponent],
  imports: [CommonModule, IonicModule.forRoot()],
  exports: [ButtonComponent, TextareaComponent, InputComponent],
})
export class FormsModule {}
